import { gql } from "@apollo/client";

export const UPSERT_MESSAGE_TEMPLATE = gql`
  mutation UpsertMessageTemplate(
    $insert_object: message_template_insert_input!
    $delete_content_ids: [uuid!]!
    $skip_delete: Boolean!
  ) {
    insert_message_template_one(
      object: $insert_object
      on_conflict: {
        constraint: message_template_pkey
        update_columns: [
          email_subject
          email_plain_text
          email_markup
          sms_body
          enabled
        ]
      }
    ) {
      id
      enabled
      message_template_rich_contents {
        message_id
        content_id
        language
      }
    }

    delete_message_template_rich_content(
      where: { content_id: { _in: $delete_content_ids } }
    ) @skip(if: $skip_delete) {
      affected_rows
    }
  }
`;
